module.exports = __webpack_public_path__ + "static/media/youtube.3e42755a.svg";